import { request } from 'utils/requests'
import { cachedFetch, cacheClear } from 'utils/memoryCache'
import { CACHE_TTL } from 'utils/cacheTtl'

const PREFIX = 'settings:actionGroups:'


export const listActionGroups = async (params = {}) => {
  try {
    return await cachedFetch(
      `${PREFIX}list:${JSON.stringify(params)}`,
      async () => request.get('/action-groups', { params }),
      { ttlMs: CACHE_TTL.SETTINGS_STABLE }
    )
  } catch (error) {
    console.error('Erro ao listar grupos de ação:', error)
    throw error
  }
}


export const getActionGroup = async (id) => {
  try {
    return await cachedFetch(
      `${PREFIX}one:${id}`,
      async () => request.get(`/action-groups/${id}`),
      { ttlMs: CACHE_TTL.SETTINGS_STABLE }
    )
  } catch (error) {
    console.error('Erro ao buscar grupo de ação:', error)
    throw error
  }
}


export const createActionGroup = async (data) => {
  try {
    const response = await request.post('/action-groups', data)
    cacheClear(PREFIX)
    return response
  } catch (error) {
    console.error('Erro ao criar grupo de ação:', error)
    throw error
  }
}


export const updateActionGroup = async (id, data) => {
  try {
    const response = await request.put(`/action-groups/${id}`, data)
    cacheClear(PREFIX)
    return response
  } catch (error) {
    console.error('Erro ao atualizar grupo de ação:', error)
    throw error
  }
}


export const deleteActionGroup = async (id) => {
  try {
    const response = await request.delete(`/action-groups/${id}`)
    cacheClear(PREFIX)
    return response
  } catch (error) {
    console.error('Erro ao excluir grupo de ação:', error)
    throw error
  }
}


export const listActiveActionGroups = async () => {
  try {
    return await cachedFetch(
      `${PREFIX}active`,
      async () => request.get('/action-groups', { params: { status: 'active' } }),
      { ttlMs: CACHE_TTL.SETTINGS_STABLE }
    )
  } catch (error) {
    console.error('Erro ao listar grupos de ação ativos:', error)
    throw error
  }
}


export const searchActionGroups = async (searchTerm) => {
  try {
    return await cachedFetch(
      `${PREFIX}search:${searchTerm}`,
      async () => request.get('/action-groups/search', { params: { q: searchTerm } }),
      { ttlMs: CACHE_TTL.SEARCH }
    )
  } catch (error) {
    console.error('Erro ao buscar grupos de ação:', error)
    throw error
  }
}
